import { NgModule } from "@angular/core";
import { NavigationService } from "src/@vex/services/navigation.service";
import { MenuService } from "./menu.service";
import { TokenService } from "./token.service";



@NgModule({
  providers : [
    MenuService,
    NavigationService,
    TokenService
  ]
})
export class MenuModule {
}
